import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { Container, Grid } from "@mui/material";
import logo from "./../../assets/safe_logo.png";
import RoundButton from "../../components/RoundButton";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { sendEmailForgotPassword } from "../../redux/forgotPassword/action";
import forgotUserNameScheme from "../../validations/forgotUserNameScheme";
import CustomLoader from "../../components/CustomLoader";
import storePersist, { localConstant } from "../../services/localStorage";
import background_image from "./../../assets/png/background_image.png";
import { useResponsive } from "../../hooks/useResponsive";
import { ReactComponent as ArrowLeftSvg } from "./../../assets/svg/arrow-left.svg";
import { useTranslation } from "react-i18next";

const EnterUserNamePage = () => {
  const { isLoading, findByEmailData } = useSelector(
    (state) => state.forgotReducer,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const smDown = useResponsive("down", "sm");
  const { t } = useTranslation();

  const formEnterUserName = (values) => {
    dispatch(
      sendEmailForgotPassword(values, (data) => {
        if (data?.user) {
          storePersist.set(localConstant.LOCAL_EMAIL, values?.email);
          data.isForgotPasswordVerify = true;
          const encodedParams = encodeURIComponent(
            `id=${data?.user?.userId}&email=${values?.email}`,
          );
          navigate(`/emailVerification?${encodedParams}`, {
            state: data,
          });
        }
      }),
    );
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: { email: findByEmailData?.userEmail },
    resolver: yupResolver(forgotUserNameScheme),
  });

  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        paddingTop: 20,
        position: "relative",
        minHeight: "100vh",
        backgroundColor: "#80BCFF4F",
        backgroundImage: `url(${background_image})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: "100vh",
      }}
    >
      <Box
        maxWidth="xs"
        sx={{
          flexGrow: 1,
          height: 1,
          minHeight: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            height: 1,
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            flexDirection: ["column", "column", "row"],
          }}
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{ height: 1, width: 1, padding: 0, gap: 5 }}
          >
            <img src={logo} alt="Your Alt Text" />
            <Card
              sx={{
                p: 3,
                pb: 0,
                width: 1,
                maxWidth: 600,
                height: smDown ? 1 : "auto",
              }}
            >
              <form onSubmit={handleSubmit((data) => formEnterUserName(data))}>
                <Grid container sx={{ mb: 3 }} direction={"row"}>
                  <ArrowLeftSvg
                    style={{ alignSelf: "center" }}
                    onClick={() => {
                      navigate(-1);
                    }}
                  />
                  <Typography
                    sx={{ ml: 1 }}
                    variant="titleText"
                    color="primary.main"
                  >
                    {t("pages.enterUsername.pageHeading")}
                  </Typography>
                </Grid>
                <Stack spacing={3}>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label={t("pages.enterUsername.text01")}
                        name="email"
                        type="email"
                        error={!!errors.email}
                        helperText={errors.email?.message}
                      />
                    )}
                  ></Controller>
                </Stack>
                <RoundButton
                  sx={{ mt: 5, mb: 5 }}
                  size="large"
                  fullWidth
                  variant="contained"
                  type="submit"
                  color="primary"
                  rounded
                >
                  {" "}
                  <Typography variant="buttonText" color="common.buttonText">
                    {t("commonLabels.text01")}
                  </Typography>
                </RoundButton>
              </form>
            </Card>
          </Stack>
        </Box>
      </Box>
      {isLoading && <CustomLoader />}
    </Container>
  );
};

export default EnterUserNamePage;
